import { useEffect, useState, useCallback } from 'react';

let deferredPrompt: any = null;
const listeners = new Set<() => void>();
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e: Event) => { e.preventDefault(); deferredPrompt = e; listeners.forEach(l => l()); });
  window.addEventListener('appinstalled', () => { deferredPrompt = null; listeners.forEach(l => l()); });
}

/** PWA telepítés: „beforeinstallprompt” elkapása és kézi indítása. */
export function usePwaInstall() {
  const [, tick] = useState(0);
  useEffect(() => { const l = () => tick(x => x + 1); listeners.add(l); return () => { listeners.delete(l); }; }, []);
  const isInstalled = typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone === true);
  const isIos = typeof navigator !== 'undefined' && /iPhone|iPad|iPod/.test(navigator.userAgent);
  const install = useCallback(async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const r = await deferredPrompt.userChoice.catch(() => ({ outcome: 'dismissed' }));
    deferredPrompt = null; listeners.forEach(l => l());
    return r?.outcome === 'accepted';
  }, []);
  return { canInstall: !!deferredPrompt, install, isInstalled, isIos };
}
